import {
  Box,
  FormControl,
  Grid,
  CardContent,
  Card,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material"
import { useState, useEffect } from "react"
import { Trans, useTranslation } from "react-i18next"
import { initialState } from "./InitialStates/RenseignementsGenerauxInitialState"
import axios from "axios"
import Turnstile, { useTurnstile } from "react-turnstile"
import "./CSS/colorMessages.css"
import appendObjectToFormData from '../utils/useFormData'
import { useNavigate } from "react-router-dom"

const FormulaireRenseignementsGeneraux = () => {
  let navigate = useNavigate()
  const [renseignements, setRenseignements] = useState(initialState)
  const [reCaptchaRequest, setReCaptcha] = useState({ reCaptchaToken: "", remoteip: null })
  const [errorPrenom, setErrorPrenom] = useState("")
  const [errorNom, setErrorNom] = useState("")
  const [errorCourriel, setErrorCourriel] = useState("")
  const [errorTelephone, setErrorTelephone] = useState("")
  const [errorSujet, setErrorSujet] = useState("")
  const [errorMessage, setErrorMessage] = useState("")
  const [errorSubmission, setErrorSubmission] = useState("")
  const [successForm, setSuccessForm] = useState("")
  const [saved, setSaved] = useState(false)
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()
  
  const decodeHtmlEntities = (text: string | null = ''): string => {
    return text 
      ? text
          .replace(/&amp;/g, '&')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&quot;/g, '"')
          .replace(/&#39;/g, "'")
      : '';
  };
  const goToConfirmation = () => {
    return navigate("/confirmation")
  }

  useEffect(() => {
    document.title = "Formulaire renseignement"
  }, [])

  const handleOnChange = (event: any) => {
    const { name, value } = event.target
    setRenseignements((prevState) => {
      return {
        ...prevState,
        [name]: value,
      }
    })
  }


  const TurnstileWidget = () => {
    const turnstile = useTurnstile()
    return (
      <Turnstile
        sitekey="0x4AAAAAAATUkYKisAyqVMcx"
        onVerify={async (token) => {
          const res = await axios.get("https://api.ipify.org/?format=json")
          setReCaptcha({ reCaptchaToken: token, remoteip: res.data.ip })
        }}
      />
    )
  }

  useEffect(() => {
    handleErrors()
  }, [renseignements])

  const handleErrors = () => {
    if (errorPrenom === t("messagesUtilisateurs.lblChampRequis") && renseignements.prenom !== "") {
      setErrorPrenom("")
    }
    if (errorNom === t("messagesUtilisateurs.lblChampRequis") && renseignements.nom !== "") {
      setErrorNom("")
    }
    if (errorCourriel === t("messagesUtilisateurs.lblChampRequis") && renseignements.courriel !== "") {
      setErrorCourriel("")
    }
    if (errorSujet === t("messagesUtilisateurs.lblChampRequis") && renseignements.sujet !== "") {
      setErrorSujet("")
    }
    if (errorMessage === t("messagesUtilisateurs.lblChampRequis") && renseignements.message !== "") {
      setErrorMessage("")
    }
  }

  const handleFormatErrors = (fieldName: string) => {
    var regexCourriel =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    var regexTelephone =
      /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
    if (fieldName === "courriel") {
      if (
        renseignements.courriel !== "" &&
        !regexCourriel.test(renseignements.courriel)
      ) {
        setErrorCourriel(t("messagesUtilisateurs.communicationRenseignement.lblFormatCourrielInvalide"))
      } else setErrorCourriel("")
    }
    else if (fieldName === "telephone") {
      if (
        renseignements.telephone !== "" &&
        !regexTelephone.test(renseignements.telephone)
      ) {
        setErrorTelephone(t("messagesUtilisateurs.communicationRenseignement.lblFormatNumeroTelephone"))
      } else setErrorTelephone("")
    }
  }

  const handleSubmit = () => {
    let error = false
    if (renseignements.prenom === "") {
      setErrorPrenom(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorPrenom("")
    if (renseignements.nom === "") {
      setErrorNom(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorNom("")
    var regexCourriel =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    var regexTelephone =
      /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
    if (renseignements.courriel === "") {
      setErrorCourriel(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else if (!regexCourriel.test(renseignements.courriel)) {
      setErrorCourriel(t("messagesUtilisateurs.communicationRenseignement.lblFormatCourrielInvalide"))
      error = true
    } else setErrorCourriel("")
    if (
      renseignements.telephone !== "" &&
      !regexTelephone.test(renseignements.telephone)
    ) {
      setErrorTelephone(t("messagesUtilisateurs.communicationRenseignement.lblFormatNumeroTelephone"))
      error = true
    } else setErrorTelephone("")
    if (renseignements.sujet === "") {
      setErrorSujet(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorSujet("")
    if (renseignements.message === "") {
      setErrorMessage(t("messagesUtilisateurs.lblChampRequis"))
      error = true
    } else setErrorMessage("")
    if (error) setErrorSubmission(t("messagesUtilisateurs.lblErreurChampsFormulaire"))
    if (!error) {

      const formData = new FormData()

      appendObjectToFormData(formData, 'renseignementsForm', renseignements)
      appendObjectToFormData(formData, 'reCaptchaRequest', reCaptchaRequest)
      formData.append('nomFormulaire', 'RenseignementsGeneraux')
      formData.append('nomEntrepriseOuIndividu', renseignements.nom)
      formData.append('adresseCourriel', renseignements.courriel)

      setLoading(true)
      setSaved(true)
      axios
        .post(
          process.env.REACT_APP_API_URL + "/v1/TraiterFormulaires/upload",
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
          }
        )
        .then((response) => {
          setSaved(true)
          setSuccessForm(t("messagesUtilisateurs.lblSuccesSoumission"))
          setErrorSubmission("")
          goToConfirmation()
        })
        .catch((error) => {
          setSaved(false)
          setSuccessForm("")
          setErrorSubmission(
            t("messagesUtilisateurs.lblErreurEnvoiFormulaire")
          )
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          })
        })
    }
    else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }
  }

  return (
    <>
      <Card className="card" sx={{ minWidth: 275 }}>
        <CardContent>
          <Box component="form" sx={{ "& > :not(style)": { m: 1 } }}>
            {successForm && (
              <strong id="success" role="alert" className="success">
                <Trans>{successForm}</Trans>
              </strong>
            )}

            {errorSubmission && (
              <strong id="error-submission" role="alert" className="error">
                <Trans>{errorSubmission}</Trans>
              </strong>
            )}
             <h1>
              <Trans>{t("formulairesRenseignementsGenerauxEtAutorisationContracter.lblPageRenseignementsGeneraux")}</Trans>
            </h1>
             <div className="amp-alert amp-alert--warning">
              <div className="amp-alert__body">
                <div className="field">
                  <div dangerouslySetInnerHTML={{__html: t("formulairesRenseignementsGenerauxEtAutorisationContracter.info")}}></div>            
                </div>
              </div>
            </div>
            <FormControl fullWidth>
              <Grid container>
                <Grid item xs={6}>
                  <FormControl className="width-98" >
                    <TextField required
                      label={<Trans>{t("formulaireContact.lblChampPrenom")}</Trans>}
                      name="prenom"
                      value={decodeHtmlEntities(renseignements.prenom || '')} 
                      onChange={handleOnChange}
                      fullWidth
                      style={{ backgroundColor: errorPrenom ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                    />
                  </FormControl>
                  <div>
                    {errorPrenom && (
                      <strong id="error-prenom" role="alert" className="error">
                        <Trans>{errorPrenom}</Trans>
                      </strong>
                    )}
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth >
                    <TextField required
                      label={<Trans>{t("formulaireContact.lblChampNom")}</Trans>}
                      name="nom"
                      value={decodeHtmlEntities(renseignements.nom || '')}
                      onChange={handleOnChange}
                      fullWidth
                      style={{ backgroundColor: errorNom ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                    />
                  </FormControl>
                  <div>
                    {errorNom && (
                      <strong id="error-nom" role="alert" className="error">
                        <Trans>{errorNom}</Trans>
                      </strong>
                    )}
                  </div>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={6}>
                  <FormControl className="width-98" >
                    <TextField required
                      label={<Trans>{t("formulaireContact.lblChampCourriel")}</Trans>}
                      name="courriel"
                      value={decodeHtmlEntities(renseignements.courriel || '')}
                      onChange={handleOnChange}
                      onBlur={() => handleFormatErrors("courriel")}
                      fullWidth
                      style={{ backgroundColor: errorCourriel ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                    />
                  </FormControl>
                  <div>
                    {errorCourriel && (
                      <strong
                        id="error-courriel"
                        role="alert"
                        className="error"
                      >
                        <Trans>{errorCourriel}</Trans>
                      </strong>
                    )}
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth >
                    <TextField
                      label={<Trans>{t("formulaireContact.lblChampTelephone")}</Trans>}
                      name="telephone"
                      value={decodeHtmlEntities(renseignements.telephone || '')}
                      onChange={handleOnChange}
                      onBlur={() => handleFormatErrors("telephone")}
                      fullWidth
                      style={{ backgroundColor: errorTelephone ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                    />
                  </FormControl>
                  <div>
                    {errorTelephone && (
                      <strong
                        id="error-telephone"
                        role="alert"
                        className="error"
                      >
                        <Trans>{errorTelephone}</Trans>
                      </strong>
                    )}
                  </div>
                </Grid>
              </Grid>
              <FormControl fullWidth >
                <TextField required
                  label={<Trans>{t("formulairesRenseignementsGenerauxEtAutorisationContracter.lblChampSujet")}</Trans>}
                  name="sujet"
                  value={decodeHtmlEntities(renseignements.sujet || '')}
                  onChange={handleOnChange}
                  fullWidth
                  style={{ backgroundColor: errorSujet ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
                />
              </FormControl>
              {errorSujet && (
                <strong id="error-sujet" role="alert" className="error">
                  <Trans>{errorSujet}</Trans>
                </strong>
              )}
            </FormControl>
            <FormControl fullWidth>
              <TextField required
                name="message"
                label={<Trans>{t("formulairesRenseignementsGenerauxEtAutorisationContracter.lblChampMessage")}</Trans>}
                multiline
                rows={8}
                onChange={handleOnChange}
                value={decodeHtmlEntities(renseignements.message || '')}
                style={{ backgroundColor: errorMessage ? 'rgba(255, 204, 204, 0.5)' : 'initial' }}
              />
            </FormControl>
            {errorMessage && (
              <strong id="error-message" role="alert" className="error">
                <Trans>{errorMessage}</Trans>
              </strong>
            )}

            {TurnstileWidget()}

            <div>
              <FormControl>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={saved}
                >
                  <Trans>{t("formulairesRenseignementsGenerauxEtAutorisationContracter.ctaSoumettre")}</Trans>
                  {loading && (<CircularProgress />)}
                </Button>
              </FormControl>
            </div>
          </Box>
        </CardContent>
      </Card>
    </>
  )
}

export default FormulaireRenseignementsGeneraux